import React, { useContext } from 'react';
import LoadingSpinner from 'components/LoadingSpinner';
import GroupTable from 'components/UiKit/GroupTable';
import StorageLocationItemRow from './components/StorageLocationItemRow';
import { StorageLocationContext } from '../../context/StorageLocationProvider';

const StorageLocationList = () => {
  const {
    state: { data, isLoading, selectedId },
    selectLocation
  } = useContext(StorageLocationContext);

  return (
    <div
      data-testid="yield-storage-locations-list"
      className="h-full bg-white overflow-y-auto"
    >
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-full">
          <LoadingSpinner
            message=""
            size={50}
            label="Loading storage locations"
          />
        </div>
      ) : (
        <>
          {!data.length ? (
            <p className="p-4 text-center">No storage locations found.</p>
          ) : (
            <GroupTable>
              {data.map(item => (
                <StorageLocationItemRow
                  key={item.id}
                  item={item}
                  isSelected={selectedId === item.id}
                  onClick={selectLocation}
                />
              ))}
            </GroupTable>
          )}
        </>
      )}
    </div>
  );
};

export default StorageLocationList;
